import base from '../../app/duck/config';

const config = { ...base };

config.LAYOUT = {};

export default config;
